document.addEventListener('DOMContentLoaded', function () {

  function updateCompareSpecRows() {
    const wrappers = document.querySelectorAll('.compare-wrapper');
    const headingRows = document.querySelectorAll(
      '.compare-table-heading .compare-specs-item'
    );

    if (!headingRows.length) return;

    const specRows = Array.from(wrappers).map(wrapper =>
      Array.from(
        wrapper.querySelectorAll('.compare-specs .compare-specs-item')
      )
    );

    headingRows.forEach((headingRow, rowIndex) => {
      let hasValue = false;

      specRows.forEach(rows => {
        const row = rows[rowIndex];

        if (!row) return;

        const value = row.textContent
          .replace(/\s+/g, ' ')
          .trim();

        // Empty values, — and - are treated as no value
        if (
          value !== '' &&
          value !== '—' &&
          value !== '-'
        ) {
          hasValue = true;
        }
      });

      headingRow.style.display = hasValue ? '' : 'none';

      specRows.forEach(rows => {
        const row = rows[rowIndex];

        if (!row) return;

        row.style.display = hasValue ? '' : 'none';
      });
    });
  }

  // Get button label from the section container
  const section = document.querySelector('.page-width.section');
  const buttonLabel = section ? section.dataset.buttonLabel : 'Shop Now';

  document.querySelectorAll('.compare-wrapper').forEach(wrapper => {

    const select = wrapper.querySelector('.compare-select');
    const img = wrapper.querySelector('.compare-img');
    const title = wrapper.querySelector('.compare-title');
    const desc = wrapper.querySelector('.compare-desc');
    const price = wrapper.querySelector('.compare-price');
    const link = wrapper.querySelector('.compare-link');
    const specsBox = wrapper.querySelector('.compare-specs');
    const isAuto = select.dataset.auto === "true";

    function updateProduct(productId) {
      const script = document.querySelector(`script[data-spec="${productId}"]`);
      if (!script) {
        console.log('No script found for product ID:', productId);
        return;
      }

      try {
        const data = JSON.parse(script.textContent);
        
        if (img) {
          const imageUrl = data.image || '';
          const imageAlt = data.title || data.dropdown_label || 'Product comparison image';
          if (imageUrl) {
            img.src = imageUrl;
            img.alt = imageAlt;
            img.removeAttribute('hidden');
            img.style.display = 'block';
          } else {
            img.removeAttribute('src');
            img.alt = '';
            img.setAttribute('hidden', '');
            img.style.display = 'none';
          }
        }

        if (title) {
          const titleText = data.title || '';
          title.textContent = titleText;
          if (titleText) {
            title.removeAttribute('hidden');
          } else {
            title.setAttribute('hidden', '');
          }
        }
        if (desc) desc.textContent = data.description || '';
        if (price) {
          const priceText = data.price_range || '';
          const priceParts = priceText.split(' - ');
          if (priceParts.length === 2 && priceParts[0].trim() === priceParts[1].trim()) {
            price.textContent = priceParts[0].trim();
            price.style.display = '';
          } else if (!priceText) {
            price.style.display = 'none';
          } else {
            price.textContent = priceText;
            price.style.display = '';
          }
        }
        
        // Update the button link with the selected product URL
        if (link) {
          link.href = data.url || '#';
        }
        
        if (specsBox && data.specs) {
          specsBox.innerHTML = `
            <div class="compare-specs-item">${data.specs.price || '—'}</div>
            <div class="compare-specs-item">${data.specs.warranty || '—'}</div>
            <div class="compare-specs-item">${data.specs.locking || '—'}</div>
            <div class="compare-specs-item">${data.specs.mounting || '—'}</div>
            <div class="compare-specs-item">${data.specs.partial_open || '—'}</div>
            <div class="compare-specs-item">${data.specs.finish || '—'}</div>
            <div class="compare-specs-item is-security">${
              data.specs.security
                ? data.specs.security.replace(
                    /(\d+)\s*stars?/gi,
                    (_, count) => '⭐'.repeat(Number(count))
                  )
                : '—'
            }</div>
            <div class="compare-specs-item">${data.specs.haul_capacity || '—'}</div>
            <div class="compare-specs-item">${data.specs.static_load_rating || '—'}</div>
            <div class="compare-specs-item">${data.specs.consumes_bed_space || '—'}</div>
            <div class="compare-specs-item">${data.specs.adapts_for_large_cargo || '—'}</div>
            <div class="compare-specs-item">${data.specs.removal_time || '—'}</div>
            <div class="compare-specs-item">${data.specs.weight || '—'}</div>
            <div class="compare-specs-item">${data.specs.installation || '—'}</div>
            <div class="compare-specs-item">${data.specs.tie_downs || '—'}</div>
            <div class="compare-specs-item">${data.specs.aluminum_gauge || '—'}</div>
            <div class="compare-specs-item">${data.specs.construction || '—'}</div>
            <div class="compare-specs-item">${data.specs.toolbox_compatible || '—'}</div>
            <div class="compare-specs-item">${data.specs.bed_rail_mount_compatible || '—'}</div>
            <div class="compare-specs-item">${data.specs.auto_tailgate_compatible || '—'}</div>
            <div class="compare-specs-item">${data.specs.backside_panel_finish || '—'}</div>
            <div class="compare-specs-item">${data.specs.panel_gauge || '—'}</div>
            <div class="compare-specs-item">${data.specs.hinges || '—'}</div>
            <div class="compare-specs-item">${data.specs.clamps || '—'}</div>
            <div class="compare-specs-item">${data.specs.dynamic_load_distributed || '—'}</div>
            <div class="compare-specs-item">${data.specs.static_load_distributed || '—'}</div>
            <div class="compare-specs-item">${data.specs.lead_time || '—'}</div>
          `;
          updateCompareSpecRows();
        }
        
        wrapper.classList.remove('is-compare-empty');
        
      } catch (e) {
        console.error('Error parsing product data:', e);
      }
    }

    if (!select) return;

    if (isAuto) {
      const selectedOption = select.querySelector('option[selected]');
      if (selectedOption && selectedOption.value) {
        updateProduct(selectedOption.value);
      } else {
        const firstOption = select.querySelector('option[value!=""]');
        if (firstOption && firstOption.value) {
          updateProduct(firstOption.value);
        }
      }
    }

    select.addEventListener('change', function () {
      const option = this.options[this.selectedIndex];
      if (option && option.value) {
        updateProduct(option.value);
      }
    });

  });

  // Equal height
  function syncCompareHeaderHeights() {
    const headers = document.querySelectorAll(".compare-header");
    if (!headers.length) return;

    headers.forEach(el => (el.style.height = "auto"));

    let maxHeight = 0;
    headers.forEach(el => {
      const h = el.getBoundingClientRect().height;
      if (h > maxHeight) maxHeight = h;
    });

    headers.forEach(el => {
      el.style.height = `${maxHeight}px`;
    });
  }

  syncCompareHeaderHeights();

  const observer = new MutationObserver(() => {
    syncCompareHeaderHeights();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });

});